<template>
  <!-- Planner top Colors -->
  <div
    class="m-4 flex justify-center overflow-hidden relative border-t border-b py-8"
  >
    <div
      v-for="(color, colorIndex) in colors.items"
      :key="colorIndex"
      class="text-center inline-block"
      :class="{ 'mr-4': colorIndex === 0 || colorIndex + 1 !== colors.items.length}"
    >
      <div class="table">
        <svg class="table-cell" height="30" width="30">
          <circle cx="15" cy="15" r="15" :fill="color.color" />
        </svg>
        <span class="table-cell align-middle text-sm pl-4">{{ color.description }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  colors: {
    type: Object,
    required: true
  }
});
</script>
